import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';

type LocalPasswordSession = {
  token: string | null;
  setToken: (token: string | null) => void;
};

const LocalPasswordSessionContext = createContext<LocalPasswordSession | null>(null);

export function LocalPasswordSessionProvider({ children }: { children: ReactNode }) {
  const [token, setToken] = useState<string | null>(null);
  const value = useMemo(() => ({ token, setToken }), [token]);
  return <LocalPasswordSessionContext.Provider value={value}>{children}</LocalPasswordSessionContext.Provider>;
}

export function useLocalPasswordSession(): LocalPasswordSession | null {
  return useContext(LocalPasswordSessionContext);
}
